<template>
  <v-layout>
    <v-dialog v-model='dialog' fullscreen persistent hide-overlay transition="dialog-bottom-transition" style="height:100%">
    <v-card
      color="white"
      style="height:100%"
    >
      <v-card-title class="blue white--text" dark>{{ 'CONFIGURATION' | translate}}</v-card-title>
      <v-card-text v-if="start">


        <v-layout justify-center row wrap>
          <v-flex xs6>
        <v-layout justify-center row wrap>
          <v-flex xs12>
            {{ 'CONFIGURATION_QUESTION' | translate}}

          </v-flex>
          <v-flex xs6>
            <v-layout row class="pa-2">
              <v-btn
                flat
                @click="startConfig()"
                class="text-none"
                color="#004884"
                outline
              >
                {{ 'BUTT_EDIT_ALREADY_CREATE' | translate}}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                flat
                @click="createNewItem"
                class="text-none"
                color="#004884"
                outline
              >
                {{ 'BUTT_CREATE_NEW_CONFIG' | translate}}
              </v-btn>
            </v-layout>
          </v-flex>

        </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text v-if="!start">
        <v-card color="white" v-if="isRemoveDialog">
          <v-card-title class="blue white--text" dark>{{ 'DIALOG_TITLE_CONFIGURATION_DELETE' | translate}}</v-card-title>
          <v-card-text>
            {{ 'LABEL_CONFIGURATION_DELETE_ITEM' | translate({'name':configName})}}
          </v-card-text>
          <v-card-actions>
            <v-btn
              flat
              @click="cancelDelete"
              class="text-none"
              color="#E05469"
              outline
            >
              {{ 'BUTT_CANCEL' | translate}}
            </v-btn>
            <v-btn
              flat
              @click="deleteCurrentItem"
              class="text-none"
              color="#004884"
              outline
            >
              {{ 'BUTT_DELETE_ITEM' | translate}}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card color="white" v-if="isDialog2">
          <v-card-title class="blue white--text" dark>{{ 'DIALOG_TITLE_CONFIGURATION_NEW' | translate}}</v-card-title>
          <v-card-text>
            {{ 'LABEL_CONFIGURATION_NEW_DESCRIPTION' | translate}}
            <v-text-field v-model="newConfigName" @click:clear="onClear" :clearable="true"
                          :label="labelConfigName"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn
              flat
              @click="cancelNewItem"
              class="text-none"
              color="#E05469"
              outline
            >
              {{ 'BUTT_CANCEL' | translate}}
            </v-btn>
            <v-btn
              flat
              @click="saveNewItem"
              class="text-none"
              color="#004884"
              outline
            >
              {{ 'BUTT_SAVE' | translate}}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-layout class="justify-start" v-if="showSelect">
          <v-flex xs12 sm6 md3 class="mx-2">
            <v-select v-model="configName"
                      :items="configNames"
                      :label="labelSearch"
                      @change="checkSelection"
            ></v-select>
          </v-flex>
          <v-btn
            flat
            v-if="!(configName !== null && configName.length > 0)"
            @click="createNewItem"
            class="text-none"
            color="#004884"
            outline
          >
            {{ 'BUTT_CREATE_NEW_CONFIG' | translate}}
          </v-btn>
          <!--
          <v-btn
            color="primary"
            flat
            v-if="false"
            @click="createNewItem"
          >
            <v-icon>add</v-icon>
          </v-btn>
          -->
          <v-tooltip top>
            <template #activator="ttData1">
              <v-btn
                color="red"
                flat
                v-on="ttData1.on"
                v-if="(configName != 'Standard') && (configName != null) && (configName != '')"
                @click="deleteItem"
              >
                <v-icon>remove</v-icon>
              </v-btn>
            </template>

            <span>{{ 'TOOLTIP_REMOVE_CONFIGURATION' | translate}}</span>

          </v-tooltip>

        </v-layout>
        <v-tabs
          v-if="showSelect && (configName != null) && (configName != '') && (tableData || tableDataSP || tableDataKZ)"
          color="white"
          light
          name="sbTabPanel"
          v-model="tab2"
          ref="myTab"
          slider-color="#8ACAC1"
          @change="onChangeTab"
          class="activetab"
        >
          <v-tab name="tabSP" href="#tabSP">{{tab1Title}}</v-tab>
          <v-tab name="tabKZ" href="#tabKZ">{{tab2Title}}</v-tab>
          <v-spacer></v-spacer>


          <div class="text-xs-center pt-0 mt-0">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filter"
              clearable
              solo
              @click:clear="onClearFilter"
              @input="onEnterFilter"
              hide-details
            ></v-text-field>
          </div>
          <v-tab-item active value="tabSP" name="tabSP" class="pa-0 ma-0 pt-2">
            <ConfigurationTable :allTablesData="tableDataSP" :heightSub="tableHeightSub" ref="tabSP"
                                tableName="tableSP" :widthSub="0"
                                edoClassName="sb"></ConfigurationTable>
          </v-tab-item>
          <v-tab-item value="tabKZ" name="tabKZ" class="pa-0 ma-0 pt-2">
            <ConfigurationTable :allTablesData="tableDataKZ" :heightSub="tableHeightSub" ref="tabKZ"
                                tableName="tableKZ" :widthSub="0"
                                edoClassName="sb"></ConfigurationTable>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
      <v-layout style="position: absolute;left:0px;bottom: 0px; height: 88px;right: 0px;z-index: 10000001;">
        <v-spacer></v-spacer>
        <v-btn
          flat
          @click="closeDialog"
          class="text-none"
          color="#E05469"
          outline
        >
          {{ 'BUTT_CANCEL' | translate}}
        </v-btn>
        <v-btn
          flat
          v-if="showSelect && configName !== null && configName.length > 0"
          @click="saveData(false)"
          class="text-none"
          color="#004884"
          outline
        >
          {{ 'BUTT_SAVE' | translate}}
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
  </v-layout>
</template>

<script>
import Vue from 'vue'
import ConfigurationTable from './../akte/ConfigurationTable'
import FixedTableIE from './../../tables/EasyTableIE'

export default {
  name: 'DialogKonfigurationRows',
  components: {FixedTableIE, ConfigurationTable},
  props: ['structureData'],
  methods: {
    onClearFilter: function () {
      this.$refs['tabSP'].onClearFilter()
      this.$refs['tabKZ'].onClearFilter()
    },
    onEnterFilter: function () {
      this.$refs['tabSP'].onEnterFilter(this.search)
      this.$refs['tabKZ'].onEnterFilter(this.search)
    },
    closeDialog: function () {
      this.$emit('close', {})
      this.showInputField = false
      this.dialog = false
    },
    cancelNewItem () {
      this.isDialog2 = false
      this.load()
    },
    cancelDelete () {
      this.isDialog2 = false
      this.isRemoveDialog = false
      this.load()
    },
    deleteItem () {
      this.showInputField = false
      this.isDialog2 = false
      this.isRemoveDialog = true
    },
    deleteCurrentItem () {
      this.showInputField = false
      this.isDialog2 = false
      this.isRemoveDialog = false
      var rk = this.structureData.commonRkNr
      var guvNr = this.structureData.commonGuvNr
      Vue.prototype.$api.deleteConfiguration(this.configName, rk, guvNr, this.onDeleteDone)
    },
    onDeleteDone () {
      this.loadConfigurationList()
    },
    saveNewItem () {
      this.showInputField = true
      this.isDialog2 = false
      this.configName = this.newConfigName
      this.saveData(true)
    },
    onChangeTab (item, preventGetPositions) {
      if (this.lastTab) {
        if (this.$refs[this.lastTab] && this.$refs[this.lastTab].close) {
          if (!preventGetPositions) {
            this.posArr[this.lastTab] = this.getPositions(this.lastTab)
          }
          this.$refs[this.lastTab].close()
        }
      }
      if (this.$refs[item] && this.$refs[item].open) {
        this.$refs[item].close()
        this.$refs[item].open(this.nTableData[item])
      }
      this.lastTab = item
    },
    /**
     * CAlled after data are loaded
     */
    open: function (data) {
      this.start = false
      this.tableData = _.clone(data)
      var cmp = this
      if (!cmp.lastTab) {
        cmp.lastTab = 'tabSP'
      }
      window.setTimeout(function () {
        cmp.onChangeTab('tabSP', true)
      }, 1000)
    },
    /**
     * Initial when Dialogs is started
     * @param data
     */
    show (data) {
      this.start = false
      // this.tab2 = 'tabSP'
      this.akresultsDialog = _.clone(data)
      this.dialog = true
      this.startConfig()
    },
    startConfig: function () {
      this.start = false
      var cmp = this
      this.$nextTick(function () {
        cmp.$nextTick(() => {
          Vue.prototype.$api.hideIdle()
          cmp.showSelect = true
          cmp.autoLoadConfig = false
          cmp.loadConfigurationList()
          cmp.configName = null
        })
      })
    },
    createNewItem: function () {
      var rk = this.structureData.commonRkNr
      var guvNr = this.structureData.commonGuvNr
      Vue.prototype.$api.showIdle()
      let cmp = this
      this.tab2 = null
      this.tableData = null
      window.setTimeout(function () {
        Vue.prototype.$api.getStrukturBilanzConfiguration(rk, guvNr, '', cmp.onGetDataNewItem)
      }, 100)
    },
    onGetDataNewItem: function (data) {
      this.start = false
      this.isDialog2 = true
      this.showSelect = false
      this.readInitialData(data)
      this.open(data)
      Vue.prototype.$api.hideIdle()
    },
    checkSelection: function () {
      if ((this.configName === Vue.i18n.translate('BTN_CONFIG_CREATE_NEW_ITEM'))) {
        this.createNewItem()
      } else {
        this.load()
      }
    },

    getPositions: function (name) {
      // tabSP
      var items = []
      var positions = []

      if (this.$refs[name]) {
        items = this.$refs[name].getAll()
        if (items.length > 0) {
          for (var i in items) {
            var module = items[i]
            var v = 0
            if (module.selected) {
              v = 1
            }
            if (module.meta.id) {
              positions.push({
                id: module.meta.id,
                value: v
              })
            }
          }
        }
      }
      return positions
    },
    saveData: function (preventGetPos) {
      //if (this.showInputField) {
      //  this.configName = this.newConfigName
      //}

      var rk = this.structureData.commonRkNr
      var guvNr = this.structureData.commonGuvNr

      if (!preventGetPos) {
        this.posArr[this.lastTab] = this.getPositions(this.lastTab)
      }

      var cmp = this
      Vue.prototype.$api.showIdle()
      Vue.prototype.$api.saveStrukturBilanzConfiguration(rk, guvNr, this.configName, cmp.posArr['tabSP'], cmp.posArr['tabKZ'], this.onSaveDone)
      this.$emit('currentConfigName', this.configName)
    },
    onClear: function () {
      this.newConfigName = ''
      this.showInputField = true
    },
    onSaveDone: function () {
      Vue.prototype.$api.hideIdle()
      if (this.newConfigName == null) {
        this.dialog = false
      }
      this.newConfigName = null
      this.start = false
      this.showSelect = true

      Vue.prototype.$eventHub.$emit('loadConfigurationList', {
        rk: this.structureData.commonRkNr,
        guvNr: this.structureData.commonGuvNr
      })
      this.loadConfigurationList()
    },
    close: function () {
      this.$emit('close', {})
      if (this.$refs.sdTable && this.$refs.sdTable.doDestroyTable) {
        this.$refs.sdTable.doDestroyTable()
      }
      Vue.prototype.$api.hideIdle()
    },
    loadConfigurationList: function () {
      var rk = this.structureData.commonRkNr
      var guvNr = this.structureData.commonGuvNr
      Vue.prototype.$api.showIdle()
      Vue.prototype.$api.getConfigurationList(rk, guvNr, this.onGetConfigurationList)
    },
    load: function () {
      var rk = this.structureData.commonRkNr
      var guvNr = this.structureData.commonGuvNr
      Vue.prototype.$api.showIdle()
      let cmp = this
      this.tab2 = null
      this.tableData = null
      window.setTimeout(function () {
        Vue.prototype.$api.getStrukturBilanzConfiguration(rk, guvNr, cmp.configName, cmp.onGetData)
      }, 100)
    },
    onGetData: function (data) {
      this.readInitialData(data)
      this.open(data)
      Vue.prototype.$api.hideIdle()
    },
    getSelectedTableId (tableData, tableName) {
      var arr = []
      var data = tableData.tables[tableName]
      if (data) {
        _.forEach(data.rows, function (row) {
          if (row.id && row.value) {
            arr.push({
              id: row.id,
              value: row.value
            })
          }
        })
      }
      return arr
    },
    readInitialData (tableData) {
      this.posArr['tabSP'] = this.getSelectedTableId(tableData, 'tableSP')
      this.posArr['tabKZ'] = this.getSelectedTableId(tableData, 'tableKZ')
      this.nTableData['tabSP'] = _.clone(tableData.tables.tableSP, true)
      this.nTableData['tabKZ'] = _.clone(tableData.tables.tableKZ, true)
      this.tab1Title = this.nTableData['tabSP'].name
      this.tab2Title = this.nTableData['tabKZ'].name
    },
    onGetConfigurationList: function (data) {
      this.configNames = [Vue.i18n.translate('LABEL_CONFIG_DEFAULT')]
      // this.configName = Vue.i18n.translate('LABEL_CONFIG_DEFAULT')
      this.labelSearch = Vue.i18n.translate('LABEL_CONFIG_SELECTION')
      this.labelConfigName =  Vue.i18n.translate('LABEL_CONFIG_NAME')
      this.configNames = this.configNames.concat(data)
      if (this.autoLoadConfig) {
        this.load()
      } else {
        Vue.prototype.$api.hideIdle()
      }
      this.autoLoadConfig = true
    }
  },
  data () {
    return {
      showSelect: false,
      pgresults: [],
      search: '',
      tab2: '',
      lastTab: 'tabSP',
      autoLoadConfig: true,
      selected: false,
      posArr: [],
      nTableData: [],
      tab1Title: '',
      tab2Title: '',
      showInputField: false,
      tableHeightSub: 0,
      tableDataSP: null,
      tableDataKZ: null,
      tableNotComplete: false,
      akresultsDialog: [],
      warning: false,
      newConfigName: null,
      currentCurrency: 1,
      warnMessage: '',
      tableData: null,
      start: false,
      keys: [],
      ttData1: {},
      configName: Vue.i18n.translate('LABEL_CONFIG_DEFAULT'),
      labelSearch: Vue.i18n.translate('LABEL_CONFIG_SELECTION'),
      labelConfigName: Vue.i18n.translate('LABEL_CONFIG_NAME'),
      configNames: [Vue.i18n.translate('LABEL_CONFIG_DEFAULT')],
      headersDialog: [],
      'tableConfig': {
        selection: true,
        isClickable: false,
        header: {
          columnClass: 'verlauf abstandunten04 theme--light blue tableIEPadding1 headcolumn'
        },
        rows: {
          rowClass: 'rowEIE'
        }
      },
      dialog: false,
      isDialog2: false,
      isRemoveDialog: false,
      items: []
    }
  },
  mounted () {
    this.keys['tabSP'] = 0
    this.keys['tabKZ'] = 0
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/dialogs/DialogKonfigurationRows.vue